import React, { useEffect } from "react";

import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import { useWallet } from "use-wallet";

import "../App.css";
import "@fontsource/roboto";
import "react-toastify/dist/ReactToastify.css";

import useTransact from "../hooks/useTransact";
import { useWalletInfoVesting } from "../hooks/useWalletInfoVesting";
import { getChainName } from "../components/constants";

import BackArrow from "../assets/back-arrow.png";

function Vesting({ tokenData, openModal }) {
  const wallet = useWallet();
  const { name, symbol, contract, chainId } = tokenData;

  const {
    setLoading,
    readWalletData,
    clearWalletData,
    claimable,
    // claiminfo,
    total,
    startTime,
    endTime,
    // lastClaimTime,
    claimed,
    loading,
  } = useWalletInfoVesting(contract);

  const [claim] = useTransact();

  const progressTotal = ((claimable + claimed) / total) * 100;
  const progressClaimed = (claimed / total) * 100;
  const progressAvailable = (claimable / total) * 100;
  const Loader = (
    <span className="loader1">
      {" "}
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </span>
  );

  const chainName = getChainName(chainId);

  useEffect(() => {
    if (wallet.account) {
      setLoading(true);
      readWalletData(wallet.account);
      // console.log(wallet.connector);

      const intervalID = setInterval(() => {
        console.log("reading");
        readWalletData(wallet.account);
      }, 30000);

      return () => clearInterval(intervalID);
    }

    if (!wallet.account) {
      clearWalletData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wallet.account]);

  useEffect(() => {
    if (wallet.status === "connected" && !wallet.account) {
      wallet.reset();
    }
  }, [wallet.status, wallet.account, wallet]);

  useEffect(() => {
    console.log(wallet.chainId, "chainID");
    console.log(wallet.account, "account");
    console.log(wallet.status, "status");
    console.log(chainId, "chain");

    if (wallet.chainId !== chainId && wallet.account) {
      toast.error(
        `Unsupported network ${wallet.chainId}. Please Connect to ${chainName}`,
      );

      wallet.reset();
      setLoading(false);
    }

    if (wallet.error) {
      toast.error(`${wallet.error}`);
    } else if (wallet.status === "connected") {
      toast(`Connected`);
    } else if (wallet.status === "disconnected") {
      toast(`Disconnected`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wallet.status, wallet.error, wallet.chainId]);

  return (
    <div className="main-box">
      <NavLink to="/">
        <div
          style={{
            marginRight: "auto",
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
          }}
        >
          <img
            src={BackArrow}
            alt="back arrow"
            style={{ width: "30px", height: "30px" }}
          />
          {"  "}
          Back
        </div>
      </NavLink>

      <h1>{name} VESTING DISTRIBUTION</h1>
      <div className="overlay">
        <p>
          Vesting Start:{" "}
          {wallet.account && !loading
            ? new Date(startTime * 1000).toUTCString()
            : ""}
          {loading ? Loader : ""}{" "}
        </p>
        <p>
          Vesting End:{" "}
          {wallet.account && !loading
            ? new Date(endTime * 1000).toUTCString()
            : ""}
          {loading ? Loader : ""}
        </p>
        <p>
          Vesting Period:{" "}
          {wallet.account ? (endTime - startTime) / 86400 + " Days" : ""}
          {loading ? Loader : ""}
        </p>

        <div className="container">
          <div className="progressbar-container">
            <div
              className="progressbar-complete"
              style={{ width: `${progressTotal ? progressTotal : 0}%` }}
            >
              <div className="progressbar-liquid"></div>
            </div>
          </div>
          <p>
            Unlocked: {(claimable + claimed).toFixed(2)}/{total.toFixed(2)}{" "}
            {symbol}
          </p>
        </div>

        <div className="box-container">
          <div className="smallbox">
            <div className="container2">
              <div className="progressbar-container2">
                <div
                  className="progressbar-complete2"
                  style={{
                    width: `${progressAvailable ? progressAvailable : 0}%`,
                  }}
                >
                  <div className="progressbar-liquid2"></div>
                </div>
              </div>
              <p>
                Available: {claimable.toFixed(2)}/{total.toFixed(2)} {symbol}
              </p>
            </div>
          </div>
          <div className="smallbox">
            <div className="container2">
              <div className="progressbar-container2">
                <div
                  className="progressbar-complete2"
                  style={{
                    width: `${progressClaimed ? progressClaimed : 0}%`,
                  }}
                >
                  <div className="progressbar-liquid2"></div>
                </div>
              </div>
              <p>
                Claimed: {claimed.toFixed(2)}/{total.toFixed(2)} {symbol}
              </p>
            </div>
          </div>
        </div>
        <div className="claim-box">
          {wallet.account && !loading && total > 0 && (
            <button onClick={() => claim(contract)}>
              Claim {claimable.toFixed(2)} {symbol}
            </button>
          )}
          {wallet.account && !loading && total === 0 && (
            <button>Nothing to Claim</button>
          )}
          {!wallet.account && (
            <button onClick={openModal} variant="primary">
              Connect Wallet
            </button>
          )}
          {wallet.account && loading && <button>Loading ...</button>}
        </div>
      </div>
    </div>
  );
}

export default Vesting;
